import { type IdTokenClaims, InteractionRequiredAuthError } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';

export const useMsalIdToken = () => {
  const { instance, accounts } = useMsal();
  const [idToken, setIdToken] = useState<string | undefined>(undefined);
  const account = accounts[0];

  useEffect(() => {
    if (!account) return;

    const tokenRequest = {
      scopes: ['openid', 'profile', 'email'],
      account,
    };

    instance
      .acquireTokenSilent(tokenRequest)
      .then((response) => {
        // MSAL checks only the access token's expiry before serving its cache, so the ID token
        // stored next to it can already be expired.
        const { exp } = response.idTokenClaims as IdTokenClaims;

        return exp !== undefined && exp * 1000 <= Date.now()
          ? instance.acquireTokenSilent({ ...tokenRequest, forceRefresh: true })
          : response;
      })
      .then((response) => {
        setIdToken(response.idToken);
      })
      .catch((error) => {
        if (error instanceof InteractionRequiredAuthError) {
          void instance.acquireTokenRedirect(tokenRequest);
          return;
        }

        console.error('Failed to acquire ID token:', error);
      });
  }, [instance, account]);

  return idToken;
};
